<template>
  <v-snackbar
    :class="classes"
    :value="value"
    v-bind="{
      ...$attrs,
      ...$props,
      'color': 'transparent'
    }"
    auto-height
    :color="$attrs.color"
    :multi-line="$attrs.mode === 'multi-line'"
    :timeout="$attrs.timeout"
    :top="$attrs.position === 'top'"
  >
    <v-row>
      <v-icon
        class="pr-3"
        dark
        large
      >
        {{ $attrs.icon }}
      </v-icon>
      <v-col>
        <div>
          <strong>{{ $attrs.title }}</strong>
        </div>
        <div>{{ $attrs.text }}</div>
      </v-col>
    </v-row>
  </v-snackbar>
</template>
<script>
  // Components
  import { VSnackbar } from 'vuetify/lib'

  export default {
    name: 'BaseUdaSnackbar',

    extends: VSnackbar,

    props: {
      dismissible: {
        type: Boolean,
        default: true,
      },
      type: {
        type: String,
        default: '',
      },
    },

    computed: {
      classes () {
        return {
          ...VSnackbar.options.computed.classes.call(this),
          'v-snackbar--material': true,
        }
      },
    },
  }
</script>

<style lang="sass">
  .v-snackbar--material
    margin-top: 32px
    margin-bottom: 32px

    .v-alert--material,
    .v-snack__wrapper
      border-radius: 4px

    .v-snack__content
      overflow: visible
      padding: 0
</style>
